module.exports = __webpack_public_path__ + "img/download-app.3a2a8406.png";